import { AppWindow, FileCode, MonitorSmartphone } from 'lucide-solid';
import { Match, mergeProps, Switch } from 'solid-js';
import { ApplicationTypeEnum } from '~/api';
import { MultiApplicationFlowType } from './utils';

type MultiAppIconsProps = {
  applicationType: ApplicationTypeEnum;
  flowType?: MultiApplicationFlowType;
};

export default function MultiAppIcons(props: MultiAppIconsProps) {
  const merged = mergeProps(
    {
      flowType: MultiApplicationFlowType.NEW_APPLICATION
    },
    props
  );

  const getCommonContainerClass = () => {
    const classList = `flex items-center justify-center`;

    if (merged.flowType === MultiApplicationFlowType.NEW_APPLICATION) {
      return `${classList} w-6 h-6`;
    }

    if (merged.flowType === MultiApplicationFlowType.EDIT_APPLICATION) {
      return `${classList} w-10 h-10`;
    }

    return `${classList} w-6 h-6`;
  };

  const getCommonIconProps = () => {
    return {
      class: `w-full h-full`,
      strokeWidth: '1'
    };
  };

  return (
    <Switch>
      <Match
        when={
          merged.applicationType === ApplicationTypeEnum.DEFAULT_APPLICATION
        }
      >
        <div class={getCommonContainerClass()}>
          <AppWindow {...getCommonIconProps()} />
        </div>
      </Match>
      <Match
        when={merged.applicationType === ApplicationTypeEnum.WEB_APPLICATION}
      >
        <div class={getCommonContainerClass()}>
          <AppWindow {...getCommonIconProps()} />
        </div>
      </Match>
      <Match
        when={
          merged.applicationType === ApplicationTypeEnum.SINGLE_PAGE_APPLICATION
        }
      >
        <div class={getCommonContainerClass()}>
          <FileCode
            {...getCommonIconProps()}
            absoluteStrokeWidth={true}
          />
        </div>
      </Match>
      <Match
        when={merged.applicationType === ApplicationTypeEnum.NATIVE_APPLICATION}
      >
        <div class={getCommonContainerClass()}>
          <MonitorSmartphone {...getCommonIconProps()} />
        </div>
      </Match>
    </Switch>
  );
}
